import Resource from "./resource";

export default class UserResource {
    id;
    resource = new Resource();
    roles;

    constructor(props) {
        Object.assign(this, props);
    }
}
